<style>
#servitudeRegisterModal .v--modal-box.v--modal {
  min-height: 450px !important;
  min-width: 900px !important;
}
#servitudeRegisterModal .modal__content {
  overflow-y: hidden !important;
}
#servitudeRegisterModal .modal__footer {
  display: none;
}
</style>

<template>
  <Modal
    modalName="servitudeRegisterModal"
    title="Rejestr służebności"
    :buttons="[]"
    :register="register"
  >
    <ServitudesTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import ServitudesTable from "../../table/ServitudesTable";

export default {
  components: {
    Modal,
    ServitudesTable
  },
  data: () => ({
    register: true
  }),
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/servitude/modals/ServitudeRegister.vue